import { Fragment } from "react";

import { useHistory } from "react-router-dom";

import EditIcon from "@material-ui/icons/Edit";

import { useNewSubscriberContext } from "../../Context/NewSubsciberContext";
import { setStatusBackToSummary } from "../../Context/NewSubscriberAction";
import { Box, Typography } from "@material-ui/core";

const labelText = {
  fontSize: "14px",
  fontWeight: 400,
  color: "#002856",
  lineHeight: "16px",
};

const bodyText = {
  fontSize: "14px",
  fontWeight: 400,
  color: "#000000",
  lineHeight: "16px",
};

const PersonalDetailsPreview = () => {
  const history = useHistory();
  const { summary, dispatch: contextDispatch } = useNewSubscriberContext();
  const {
    FirstName = "-",
    DOB = "-",
    Gender = "-",
    FatherFirstName = "-",
    MotherFirstName = "-",
    Mobile = "-",
    EmailId = "-",
    Occupation = "-",
    ResidenceType = "-",
    CityofBirth = "-",
    CountryofBirth = "-",
    Nationality = "-",
    MaritalStatus = "-",
    SpouceFirstName,
  } = summary?.data?.objPersonalDetails[0];
  const back = () => {
    contextDispatch(setStatusBackToSummary(true));
    history.push({
      pathname: "/nps/AddSubs/personal-details",
    });
  };
  return (
    <Fragment>
      <div className="new-subscriber-container">
        <div
          style={{
            paddingLeft: "16px",
            fontSize: "18px",
            color: "#000000",
            fontWeight: "400",
            opacity: "0.8",
            paddingBottom: "4px",
          }}
        >
          PERSONAL DETAILS
        </div>
        <EditIcon className="cursor" onClick={back} />
      </div>
      <Box
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr",
          gridRowGap: "2rem",
          padding: "20px 10px 20px 6px",
          margin: "0px 10px 20px 50px",
        }}
      >
        <div>
          <Typography style={labelText}>Applicant Name</Typography>
          <Typography style={bodyText}>{FirstName || "-"}</Typography>
        </div>
        <div>
          <Typography style={labelText}>Country of Birth</Typography>
          <Typography style={bodyText}>{CountryofBirth || "-"}</Typography>
        </div>
        <div>
          <Typography style={labelText}>Mother's Name</Typography>
          <Typography style={bodyText}>{MotherFirstName || "-"}</Typography>
        </div>
        <div>
          <Typography style={labelText}>Mobile No</Typography>
          <Typography style={bodyText}>{Mobile || "-"}</Typography>
        </div>
        <div>
          <Typography style={labelText}>City of Birth</Typography>
          <Typography style={bodyText}>{CityofBirth || "-"}</Typography>
        </div>
        <div>
          <Typography style={labelText}>Marital Status</Typography>
          <Typography style={bodyText}>{MaritalStatus || "-"}</Typography>
        </div>
        <div>
          <Typography style={labelText}>Email ID</Typography>
          <Typography style={bodyText}>{EmailId || "-"}</Typography>
        </div>
        <div>
          <Typography style={labelText}>Nationality</Typography>
          <Typography style={bodyText}>{Nationality || "-"}</Typography>
        </div>
        <div>
          <Typography style={labelText}>Occupation Details</Typography>
          <Typography style={bodyText}>{Occupation || "-"}</Typography>
        </div>
        <div>
          <Typography style={labelText}>Status of Residence</Typography>
          <Typography style={bodyText}>{ResidenceType || "-"}</Typography>
        </div>
        <div>
          <Typography style={labelText}>Gender</Typography>
          <Typography style={bodyText}>{Gender || "-"}</Typography>
        </div>
        <div>
          <Typography style={labelText}>Date of Birth</Typography>
          <Typography style={bodyText}>{DOB || "-"}</Typography>
        </div>
        <div>
          <Typography style={labelText}>Father’s Name</Typography>
          <Typography style={bodyText}>{FatherFirstName || "-"}</Typography>
        </div>
        {SpouceFirstName ? (
          <div>
            <Typography style={labelText}>Spouse's Name</Typography>
            <Typography style={bodyText}>{SpouceFirstName}</Typography>
          </div>
        ) : null}
      </Box>
    </Fragment>
  );
};

export default PersonalDetailsPreview;
